import { useState } from "react";
import { api } from "../api.ts";
import { AvisoError, useAccion } from "../pantallas/comun.tsx";

interface Respuesta { enviado: boolean; enlace: string | null; destino: string; texto: string; aviso?: string; documento: string; firmado: boolean; vence: string }
const fecha = (iso: string) => new Date(iso).toLocaleDateString("es-EC", { day: "numeric", month: "long", timeZone: "America/Guayaquil" });

/**
 * Envía por WhatsApp un recibo, certificado, receta, consentimiento o indicaciones post operatorias: el paciente recibe un enlace (vale 7 días) que abre el PDF desde su celular.
 * Con WhatsApp Business sale directo; si no, se abre WhatsApp con el mensaje listo y solo se toca Enviar.
 */
export function EnviarWhatsApp({ tipo, id }: { tipo: "abono" | "certificado" | "receta" | "consentimiento" | "indicacion" | "sonrisa" | "simulacion" | "presupuesto"; id: string }) {
  const [r, setR] = useState<Respuesta | null>(null);
  const a = useAccion();
  async function enviar() {
    setR(null);
    const x = await a.correr(() => api<Respuesta>("POST", `/api/documentos/${tipo}/${id}/whatsapp`));
    if (!x) return;
    setR(x);
    if (!x.enviado && x.enlace) window.open(x.enlace, "_blank", "noopener");
  }
  return (
    <span className="enviar-wa">
      <button className="btn chico" onClick={enviar} disabled={a.ocupado} title="Envía al paciente un enlace para ver o descargar el documento">{a.ocupado ? "Enviando…" : "Enviar por WhatsApp"}</button>
      {r && (
        <small className="aviso ok" role="status">
          {r.enviado ? <>Enviado por WhatsApp a +{r.destino}. </> : <>{r.aviso ? `${r.aviso} ` : ""}Se abrió WhatsApp con el mensaje listo: solo toca Enviar. Si no se abrió, <a href={r.enlace ?? "#"} target="_blank" rel="noopener">toca aquí</a>. </>}
          El enlace vale hasta el {fecha(r.vence)}{r.firmado ? " · documento con firma digital" : ""}.
        </small>
      )}
      <AvisoError error={a.error} />
    </span>
  );
}
